import { mapGetters } from 'vuex';
import { planTypes, AUTO_ADD_BASE_PLAN_CODES, AUDIO_SUB_TYPES, AccountType } from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { ONLINE_NOT_SUPPORT_BILLING_CYCLE } from '@/common/service/non-standard-billing-cycle-utils';

export default {
  data() {
    return {
      hasModifyCapacity: false
    };
  },
  computed: {
    ...mapGetters([
      'getCurrentMeetingPlans',
      'getCurrentBasePlanInfo',
      'getSelectedPlans',
      'fromCampaignLink',
      'plancodeMapSubscriptionDisabled',
      'boughtPlans',
      'basicConfig',
      'useSpecialSupportCoupon',
      'currentEditPlan'
    ]),
    currentBasePlans() {
      return this.getCurrentMeetingPlans.length ? this.getCurrentMeetingPlans : this.getCurrentBasePlanInfo?.plans;
    },
    mx_currentPlans() {
      const planType = this.configPlanType === planTypes.EVENT_SAAS_CORE ? this.configPlanType : this.planType
      return this.selectedPlanList?.filter((item) => item.type === planType) || [];
    },
    mx_canAutoAdd() {
      const autoAddBasePlans = this.currentBasePlans.filter((plan) =>
        AUTO_ADD_BASE_PLAN_CODES.includes(plan.plan_code),
      );
      const hasAudioUnlimited = !!this.boughtPlans.find(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED);
      //isCustomPricing4MajorPlan means multiple pro/biz plan, not include single customer rate plan
      const isMultipleRatePlan = this.basicConfig?.isCustomPricing4MajorPlan;
      const isSingleRateOrSupportMultipleRate = !isMultipleRatePlan || autoAddBasePlans.every((plan) => (plan?.ratePlans?.length > 1));
      const isEnableStatus = autoAddBasePlans.every((plan) => !this.plancodeMapSubscriptionDisabled[plan.plan_code]);
      const isSpecialBillingCycle =  ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(this.currentBasePlans[0]?.billing_cycle);
      const hasMeetingPlan = this.boughtPlans.find(item => item.type === planTypes.ZOOM_MEETING)
      const isAdd = this.$config('enableAddonsAutoAddForAdd2Cart') && [flowTypes.add2cart].includes(pageConfig.type) && !isMultipleRatePlan
        && !isSpecialBillingCycle && !hasMeetingPlan
      const useSpecialSupportCoupon = this.useSpecialSupportCoupon;
      // if the customer exist special support coupon, then auto applied, will block auto add function
      if (useSpecialSupportCoupon) return false;

      return (
        pageConfig.accountType !== AccountType.ACCOUNT_ACTIVE_HOST &&
        this.mx_currentPlans.length &&
        this.currentBasePlans.length === 1 &&
        autoAddBasePlans.length === 1 &&
        !this.hasModifyCapacity &&
        !this.fromCampaignLink &&
        isSingleRateOrSupportMultipleRate &&
        !hasAudioUnlimited &&
        isEnableStatus
        && (isAdd || ![flowTypes.add2cart].includes(pageConfig.type))
      );
    },
  },
  created() {
    this.hasModifyCapacity = this.mx_getInitHasModifyCapacityValue();
  },
  methods: {
    mx_getInitHasModifyCapacityValue() {
      if (
        !this.$context.is.edit ||
        !this.currentEditPlan ||
        !this.currentEditPlan.type
      ) return false;

      const currentPlan = this.mx_currentPlans.find(item => item.type === this.currentEditPlan.type);
      if (!currentPlan) return false;

      return currentPlan.category !== this.currentEditPlan.category;
    },
  },
};
